/* QUILTZA header: mega menü, arama paneli, mobil çekmece (odak tuzağı, ESC). Vanilla JS. */
(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function init(root) {
    if (!root || root.dataset.qzReady) return;
    root.dataset.qzReady = 'true';
    var html = document.documentElement;

    /* ---------- Mega menü ---------- */
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-qz-mega-item]'));
    var closeTimer = null;
    function closeAll(except) {
      items.forEach(function (it) {
        var t = it.querySelector('[data-qz-mega-toggle]');
        var p = it.querySelector('[data-qz-mega]');
        if (!t || !p || it === except) return;
        t.setAttribute('aria-expanded', 'false');
        p.hidden = true;
      });
    }
    function open(it) {
      var t = it.querySelector('[data-qz-mega-toggle]');
      var p = it.querySelector('[data-qz-mega]');
      if (!t || !p) return;
      closeAll(it);
      t.setAttribute('aria-expanded', 'true');
      p.hidden = false;
    }
    items.forEach(function (it) {
      var t = it.querySelector('[data-qz-mega-toggle]');
      if (!t) {
        it.addEventListener('mouseenter', function () { closeAll(null); });
        return;
      }
      var hoverable = window.matchMedia('(hover: hover)');
      it.addEventListener('mouseenter', function () { if (!hoverable.matches) return; clearTimeout(closeTimer); open(it); });
      it.addEventListener('mouseleave', function () { if (!hoverable.matches) return; closeTimer = setTimeout(function () { closeAll(null); }, 150); });
      t.addEventListener('click', function () {
        if (t.getAttribute('aria-expanded') === 'true') closeAll(null); else open(it);
      });
      it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) closeAll(null); });
    });

    /* ---------- Arama ---------- */
    var searchBtn = root.querySelector('[data-qz-search-open]');
    var search = root.querySelector('[data-qz-search]');
    function setSearch(on) {
      if (!search || !searchBtn) return;
      search.hidden = !on;
      searchBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var i = search.querySelector('input[type="search"]'); if (i) i.focus(); }
    }
    if (searchBtn && search) {
      searchBtn.addEventListener('click', function () { setSearch(search.hidden); });
      var sc = search.querySelector('[data-qz-search-close]');
      if (sc) sc.addEventListener('click', function () { setSearch(false); searchBtn.focus(); });
    }

    /* ---------- Mobil çekmece ---------- */
    var burger = root.querySelector('[data-qz-drawer-open]');
    var drawer = root.querySelector('[data-qz-drawer]');
    var rootPanel = drawer && drawer.querySelector('[data-qz-panel="root"]');
    function showPanel(panel) {
      drawer.querySelectorAll('[data-qz-panel]').forEach(function (p) {
        var on = p === panel;
        p.classList.toggle('is-active', on);
        if (on) p.hidden = false;
      });
      if (panel !== rootPanel) {
        drawer.querySelectorAll('[data-qz-panel]').forEach(function (p) { if (p !== panel && p !== rootPanel) p.hidden = true; });
      }
      var f = panel.querySelector(FOCUSABLE);
      if (f) f.focus({ preventScroll: true });
    }
    function setDrawer(on) {
      if (!drawer || !burger) return;
      drawer.hidden = !on;
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      html.classList.toggle('qz-lock', on);
      if (on) { showPanel(rootPanel); var c = drawer.querySelector('[data-qz-drawer-close]'); if (c) c.focus(); }
      else { burger.focus(); }
    }
    if (burger && drawer) {
      burger.addEventListener('click', function () { setDrawer(true); });
      drawer.querySelector('[data-qz-drawer-close]').addEventListener('click', function () { setDrawer(false); });
      drawer.addEventListener('click', function (e) {
        var sub = e.target.closest('[data-qz-sub]');
        if (sub) {
          var panel = document.getElementById(sub.dataset.qzSub);
          if (panel) { sub.setAttribute('aria-expanded', 'true'); showPanel(panel); drawer._lastSub = sub; }
          return;
        }
        if (e.target.closest('[data-qz-back]')) {
          showPanel(rootPanel);
          if (drawer._lastSub) { drawer._lastSub.setAttribute('aria-expanded', 'false'); drawer._lastSub.focus({ preventScroll: true }); }
        }
      });
      /* Odak tuzağı */
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var nodes = Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (n) {
          return n.offsetParent !== null && !n.closest('[hidden]') && !n.closest('.qz-drawer__panel:not(.is-active)');
        });
        if (!nodes.length) return;
        var first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      window.matchMedia('(min-width: 990px)').addEventListener('change', function (m) { if (m.matches && !drawer.hidden) setDrawer(false); });
    }

    /* ---------- ESC ---------- */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && !drawer.hidden) { setDrawer(false); return; }
      if (search && !search.hidden) { setSearch(false); searchBtn.focus(); return; }
      var openToggle = root.querySelector('[data-qz-mega-toggle][aria-expanded="true"]');
      if (openToggle) { closeAll(null); openToggle.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { closeAll(null); if (search && !search.hidden) setSearch(false); }
    });
  }
  function boot() { document.querySelectorAll('[data-qz-header]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
